// Replace direct database calls with API calls to backend

export async function createPost(post: any) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(post)
    });
    
    if (!response.ok) {
      throw new Error('Failed to create post');
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating post:', error);
    throw error;
  }
}

export async function deletePost(id: number) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to delete post');
    }
    return await response.json();
  } catch (error) {
    console.error('Error deleting post:', error);
    throw error;
  }
}

export async function updatePost(id: number, data: any) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error('Failed to update post');
    }
    return await response.json();
  } catch (error) {
    console.error('Error updating post:', error);
    throw error;
  }
}

export async function quotePost(originalPostId: string, content: string) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${originalPostId}/quote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ content })
    });
    
    if (!response.ok) {
      throw new Error('Failed to quote post');
    }
    return await response.json();
  } catch (error) {
    console.error('Error quoting post:', error);
    throw error;
  }
}

export async function updatePostsByFilter(filter: any, data: any) {
  // This would need a bulk update endpoint in the backend
  // For now, throw an error to identify where this is used
  throw new Error('Bulk post updates not implemented - use individual updates');
}